"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../common/Utilities");
var TelemetryHelper_1 = require("./TelemetryHelper");
var RawLogger = /** @class */ (function () {
    function RawLogger(sdk, logger) {
        this.sdk = sdk;
        this.logger = logger;
    }
    RawLogger.prototype.log = function (loglevel, telemetryEvent, customData) {
        if (this.isLoggingEnabled()) {
            var logData = TelemetryHelper_1.default.getTelemetryEventData(this.sdk, telemetryEvent, customData);
            this.logEvent(loglevel, logData);
        }
    };
    RawLogger.prototype.logEvent = function (logLevel, logData) {
        if (this.isLoggingEnabled()) {
            setTimeout(this.logger.logClientSdkTelemetryEvent.bind(this.logger), 0, logLevel, logData);
        }
    };
    RawLogger.prototype.isLoggingEnabled = function () {
        return !Utilities_1.default.isNullOrUndefined(this.logger);
    };
    return RawLogger;
}());
exports.default = RawLogger;
//# sourceMappingURL=RawLogger.js.map